<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V12C4 11.2667 4.26111 10.6389 4.78333 10.1167C5.30556 9.59444 5.93333 9.33333 6.66667 9.33333H9.33333V6.66667C9.33333 5.93333 9.59444 5.30556 10.1167 4.78333C10.6389 4.26111 11.2667 4 12 4H20C20.7333 4 21.3611 4.26111 21.8833 4.78333C22.4056 5.30556 22.6667 5.93333 22.6667 6.66667V14.6667H25.3333C26.0667 14.6667 26.6944 14.9278 27.2167 15.45C27.7389 15.9722 28 16.6 28 17.3333V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H17.3333V22.6667H14.6667V28H6.66667ZM6.66667 25.3333H9.33333V22.6667H6.66667V25.3333ZM6.66667 20H9.33333V17.3333H6.66667V20ZM6.66667 14.6667H9.33333V12H6.66667V14.6667ZM12 20H14.6667V17.3333H12V20ZM12 14.6667H14.6667V12H12V14.6667ZM12 9.33333H14.6667V6.66667H12V9.33333ZM17.3333 20H20V17.3333H17.3333V20ZM17.3333 14.6667H20V12H17.3333V14.6667ZM17.3333 9.33333H20V6.66667H17.3333V9.33333ZM22.6667 25.3333H25.3333V22.6667H22.6667V25.3333ZM22.6667 20H25.3333V17.3333H22.6667V20Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "CityIcon",
};
</script>

<style scoped></style>
